export default __webpack_public_path__ + "static/media/20_LANCER.ef2bfe3e.png";